import { useState, useEffect } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import NewPlatform from "views/platforms/new-platform";


// Soft UI Dashboard PRO React context
import { useSoftUIController } from "context";

function CreatePlatform({
  id,
  platformName,
  platformExchange,
  vlcourtEmail,
  vlcourtPassword,
  queueIdentifier,
  routingKey,
  rmqsSelected,
  settleOnlyBets,
  validateBets,
  receiveSeperateStatistics,
  riskManagement,
  demo,
  hardProviderDown,
  nuRemove,
  compressMessage,
  traderView,
  promos,
  outrights,
  logo,
  masterId,
  showFilters,
  showModal,
  signalCloseModal,
}) {
  const [open, setOpen] = useState(false);
  const [editMode, seteditMode] = useState(id ? true : false);
  const [checkToClose, setCheckToclose] = useState(false);
  const [editable, setEditable] = useState(false);

  const [controller] = useSoftUIController();
  const { permissions } = controller;

  const handleCancelCreation = (update, name) => {
    // setOpen(false);
    // signalCloseModal(update, null);
    setCheckToclose(true);
  };

  const handleCloseCreation = (update, cancelData) => {
    if (update) {
      setOpen(false);
      id = 0;
      platformName = null;
      platformExchange = null;
      vlcourtEmail = null;
      vlcourtPassword = null;
      queueIdentifier = null;
      rmqsSelected = [];
      outrights = 3;
      signalCloseModal(update, cancelData);
    } else {
      if (!cancelData) {
        setOpen(false);
        id = 0;
        platformName = null;
        platformExchange = null;
        vlcourtEmail = null;
        vlcourtPassword = null;
        queueIdentifier = null;
        rmqsSelected = [];
        outrights = 3;
        signalCloseModal(update, cancelData);
      }
    }
    setCheckToclose(false);
  };

  // const handleCancelCreation = (update, name) => {
  //   setOpen(false);
  //   id = 0;
  //   platformName = null;
  //   platformExchange = null;
  //   signalCloseModal(update, name);
  // };

  
  useEffect(() => {
    setOpen(showModal);
  }, [showModal]);

  useEffect(() => {
    if (
      permissions.length > 0 &&
      (permissions.indexOf("management-platforms-edit") > -1 || permissions.indexOf("super") > -1)
    ) {
      setEditable(true);
    }
  }, [permissions]);

  return (
    <div>
      <Dialog open={open} onClose={handleCancelCreation} fullWidth={true} maxWidth={"xxl"}>
        <DialogTitle>
          {id > 0 ? (editable ? "Edit Platform" : "Platform info") : "Create New Platform"}
        </DialogTitle>
        <DialogContent>
          <NewPlatform
            signalCloseModal={handleCloseCreation}
            id={id}
            platformName={platformName}
            platformExchange={platformExchange}
            vlcourtEmail={vlcourtEmail}
            vlcourtPassword={vlcourtPassword}
            queueIdentifier={queueIdentifier}
            routingKey={routingKey}
            rmqsSelected={rmqsSelected}
            settleOnlyBets={settleOnlyBets}
            validateBets={validateBets}
            receiveSeperateStatistics={receiveSeperateStatistics}
            riskManagement={riskManagement}
            demo={demo}
            hardProviderDown={hardProviderDown}
            nuRemove={nuRemove}
            compressMessage={compressMessage}
            traderView={traderView}
            promos={promos}
            outrights={outrights}
            logo={logo}
            masterId={masterId}
            showFilters={showFilters}
            checkToClose={checkToClose}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
}

// Setting default values for the props of CreatePlatform
CreatePlatform.defaultProps = {
  showModal: true,
  signalCloseModal: () => {
    //console.log("close Modal");
  },
};

// Typechecking props of the CreatePlatform
CreatePlatform.propTypes = {
  id: PropTypes.number,
  platformName: PropTypes.string,
  platformExchange: PropTypes.string,
  vlcourtEmail: PropTypes.string,
  vlcourtPassword: PropTypes.string,
  queueIdentifier: PropTypes.string,
  routingKey: PropTypes.string,
  rmqsSelected: PropTypes.array,
  settleOnlyBets: PropTypes.bool,
  validateBets: PropTypes.bool,
  receiveSeperateStatistics: PropTypes.bool,
  riskManagement: PropTypes.bool,
  demo: PropTypes.bool,
  hardProviderDown: PropTypes.bool,
  nuRemove: PropTypes.bool,
  compressMessage: PropTypes.bool,
  traderView: PropTypes.bool,
  promos: PropTypes.bool,
  outrights: PropTypes.number,
  logo: PropTypes.string,
  masterId: PropTypes.number,
  showModal: PropTypes.bool,
  signalCloseModal: PropTypes.func,
  showFilters: PropTypes.bool,
};

export default CreatePlatform;
